module.exports = __webpack_public_path__ + "img/m_bg3.41fe49a7.png";